import { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { useGetTopics } from "../../../api/queries";
import Spinner from "../../../componentLibrary/Spinner";
import { ErrorDisplay } from "../../../utils/ErrorHandling";

export default function ToolboxManager() {
  const { data: topics, isError, isLoading, error } = useGetTopics();

  const [topicPickerOpen, setTopicPickerOpen] = useState(false);

  if (isLoading) {
    return (
      <div className="flex justify-center py-12">
        <Spinner className="w-8" />
      </div>
    );
  }

  if (isError || !topics) {
    return <ErrorDisplay error={error} messageSource="api" />;
  }

  return (
    <div className="pt-4">
      <div className="mb-2">
        <div className="flex items-center justify-between">
          <p className="text-xs font-semibold uppercase tracking-widest text-gray-400 mb-1">
            Toolbox Manager
          </p>
        </div>

        <div className="relative w-fit">
          <button
            type="button"
            onClick={() => setTopicPickerOpen((o) => !o)}
            className="group flex items-center gap-2 text-left"
          >
            <span className="text-2xl font-bold text-gray-400 group-hover:text-gray-500 transition-colors">
              Select a topic…
            </span>
            <ChevronDownIcon
              className={`w-5 h-5 text-gray-400 shrink-0 transition-transform ${topicPickerOpen ? "rotate-180" : ""}`}
            />
          </button>

          {topicPickerOpen && (
            <div className="absolute left-0 top-full mt-1 z-20 w-64 rounded-lg border border-gray-200 bg-white shadow-lg py-1 max-h-72 overflow-y-auto">
              {topics.map((t) => (
                <Link
                  key={t._id}
                  to={`/admin/toolboxes/${t.slug}`}
                  className="w-full flex items-center gap-3 px-3 py-2 text-sm text-left hover:bg-gray-50 transition-colors text-gray-700"
                >
                  <img
                    src={t.icon.src}
                    alt={t.icon.alt || t.title}
                    className="w-5 h-5 object-contain shrink-0"
                  />
                  {t.title}
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>
      <div className="flex items-center justify-center rounded-xl border-2 border-dashed border-gray-300 bg-gray-50 py-20 mt-4">
        <p className="text-gray-400 text-sm">
          Select a topic to start building.
        </p>
      </div>
    </div>
  );
}
